module.exports = __webpack_public_path__ + "img/play.f7ad8851.svg";